import { Map } from 'immutable';
import {
  REQUEST_PICKUPCODE,
  REQUEST_PICKUPCODE_SUCCESS,
  REQUEST_PICKUPCODE_ERROR,
  REQUEST_PICKUPCODE_LOADING
} from '../components/KioskPickup/KioskPickupActions';
import { initialSettings } from './data';

const kiosk = (state = Map(initialSettings), action) => {
  switch (action.type) {
    case 'UPDATE_DATA':
      if (action.box && action.box.box) {
        return Map({
          ...state,
          box: action.box.box
        });
      } else {
        return Map({
          ...state
        });
      }
    case 'INITIAL_DATA':
      return Map({
        box: action.box.box
      });
    // case 'UPDATE_POLLING_STATS':
    //   return Map({
    //     ...state,
    //     pollingStats: action.stats
    //   });
    case REQUEST_PICKUPCODE:
      return Map({});
    case REQUEST_PICKUPCODE_SUCCESS:
      return Map({});
    case REQUEST_PICKUPCODE_ERROR:
      return Map({});
    case REQUEST_PICKUPCODE_LOADING:
      return Map({});
    case 'KIOSK/ENROLL_NEW_PATIENT':
      return Map({
        state
        // patients: [action.payload]
      });
    case 'KIOSK/CONFIRM_USER':
      return Map({
        ...state
        // state: {
        //   ...state
        // }
      });
    default:
      return state;
  }
};

export default kiosk;
